import React from "react";
import PropTypes from "prop-types";

import { Labeled } from "@lifepay/rc-ui-toolkit";

import { TRANSACTION_SMS_STATUSES } from "../CONSTANTS";

function SMSStatusLabel(props) {
  const { status } = props;

  switch (status) {
    case TRANSACTION_SMS_STATUSES.NOT_PROCESSED: {
      return (
        <Labeled label={"Cтатус"} type={"gray"}>
          {"SMS ‎ожидает отправки (отправка каждые 30 секунд)"}
        </Labeled>
      );
    }
    case TRANSACTION_SMS_STATUSES.SENT: {
      return (
        <Labeled label={"Cтатус"} type={"green"}>
          {"OK"}
        </Labeled>
      );
    }
    case TRANSACTION_SMS_STATUSES.SWITCHED_OFF: {
      return (
        <Labeled label={"Cтатус"} type={"green"}>
          {"SMS оповещения отключены (на момент транзакции)"}
        </Labeled>
      );
    }
    case TRANSACTION_SMS_STATUSES.ERROR_PROC: {
      return (
        <Labeled label={"Cтатус"} type={"red"}>
          {"Ошибка на стороне процессинга"}
        </Labeled>
      );
    }
    case TRANSACTION_SMS_STATUSES.ERROR_PROVIDER: {
      return (
        <Labeled label={"Cтатус"} type={"red"}>
          {"Ошибка на стороне провайдера отправлений"}
        </Labeled>
      );
    }
    default: {
      return (
        <Labeled label={"Cтатус SMS"} type={"red"}>
          {"Неопознанный статус SMS"}
        </Labeled>
      );
    }
  }
}

SMSStatusLabel.displayName = "SMSStatusLabel";

SMSStatusLabel.propTypes = {
  type: PropTypes.number,
};

SMSStatusLabel.defaultProps = {};

export default SMSStatusLabel;



// WEBPACK FOOTER //
// ./src/components/processing/transaction/SMSStatusLabel.js